// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"swiper_wrapper__3mW3H","leftPadding":"swiper_leftPadding__Nz0UR"};